import { ErrorHistoryCode, HISTORY_CODES } from 'dex-app.cm';

export const defaultMessages = {
  [HISTORY_CODES.BATCH]: 'Batch',
  [HISTORY_CODES.BATCH_SUCCESS]: 'Batch success',
  [HISTORY_CODES.BATCH_ERROR]: 'Batch error',
  [HISTORY_CODES.C1_ORDER]: 'An action with order',
  [HISTORY_CODES.C2_ORDER]: 'An action with order',
  [HISTORY_CODES.TRANSFER]: 'SWAP Action',
  [HISTORY_CODES.L1_TX]: 'L1 Tx',
  [HISTORY_CODES.TAKE_ORDER]: 'Take order',
  [HISTORY_CODES.COLLATERAL]: 'Collateral Action',
  [HISTORY_CODES.ERROR]: 'An unexpected error occurred',
  [HISTORY_CODES.BAD_REQUEST]: 'Invalid call parameters',
  [HISTORY_CODES.FORBIDDEN]: 'Access is forbidden',
  [HISTORY_CODES.NOT_FOUND]: 'Requested resource not found',
  [HISTORY_CODES.CONFLICT]: 'Action does not match the contract state',
  [HISTORY_CODES.CONTRACT_ERROR]: 'An unexpected error in contract implementation',
  [HISTORY_CODES.NOT_IMPLEMENTED]: 'Functionality not implemented',
  [HISTORY_CODES.TIMEOUT]: 'The expected action did not occur within the specified time.',
  [HISTORY_CODES.SUCCESS]: 'Operation completed successfully',
  [HISTORY_CODES.C1_ORDER_NOT_CREATED]: 'Order creation failed',
  [HISTORY_CODES.C1_ORDER_CREATED]: 'Order created',
  [HISTORY_CODES.C1_ORDER_NOT_CLOSED]: 'Order closing failed',
  [HISTORY_CODES.C1_ORDER_DEACTIVATED]: 'Order deactivated',
  [HISTORY_CODES.C1_ORDER_CLOSED]: 'Order closed',
  [HISTORY_CODES.C1_ORDER_NOT_ACTIVE]: 'Order is not active',
  [HISTORY_CODES.C1_BAD_L1_TX]: 'Invalid L1 transaction',
  [HISTORY_CODES.C1_L1_TX_HANDLING_ERROR]: 'Error handling L1 transaction',
  [HISTORY_CODES.C1_L1_EVENT_ERROR]: 'Error processing L1 event',
  [HISTORY_CODES.C1_L1_TX_HANDLED]: 'L1 transaction handled',
  [HISTORY_CODES.C1_L1_TRANSFER_TX_HANDLED]: 'L1 SWAP transaction',
  [HISTORY_CODES.C1_L1_TAKE_TX_HANDLED]: 'L1 take order transaction',
  [HISTORY_CODES.C1_ORDER_USED]: 'Order used',
  [HISTORY_CODES.C1_ORDER_UPDATED]: 'Order updated',
  [HISTORY_CODES.C1_ORDER_COMPLETED]: 'Order completed',
  [HISTORY_CODES.C1_ORDER_EXPIRED]: 'Order expired',
  [HISTORY_CODES.C2_ORDER_NOT_CREATED]: 'Order creation failed',
  [HISTORY_CODES.C2_ORDER_CREATED]: 'Order created',
  [HISTORY_CODES.C2_ORDER_NOT_CLOSED]: 'Order closing failed',
  [HISTORY_CODES.C2_ORDER_CLOSED]: 'Order closed',
  [HISTORY_CODES.C2_ORDER_DISABLED]: 'Order disabled',
  [HISTORY_CODES.C2_ORDER_NOT_ACTIVE]: 'Order is not active',
  [HISTORY_CODES.C2_ORDER_USED]: 'Order used',
  [HISTORY_CODES.C2_ORDER_UPDATED]: 'Order updated',
  [HISTORY_CODES.C2_ORDER_EXPIRED]: 'Order expired',
  [HISTORY_CODES.C2_REQUEST_NOT_CREATED]: 'Request creation failed',
  [HISTORY_CODES.C2_FITTING_ORDER_NOT_FOUND]: 'No matching order found',
  [HISTORY_CODES.C2_BTC_NONCE_NOT_AVAILABLE]: 'BTC nonce not available',
  [HISTORY_CODES.C2_L1_EVENT_ERROR]: 'Error processing L1 event',
  [HISTORY_CODES.C2_REQUEST_CREATED]: 'Request created',
  [HISTORY_CODES.C2_REQUEST_UPDATED]: 'Request updated',
  [HISTORY_CODES.C2_REQUEST_FALLBACK_CALL]: 'Fallback call',
  [HISTORY_CODES.C2_L1_TX_HANDLING_ERROR]: 'Error handling L1 transaction',
  [HISTORY_CODES.C2_BAD_L1_TX]: 'Invalid L1 transaction',
  [HISTORY_CODES.C2_REQUEST_NOT_ACTIVE]: 'Request is not active',
  [HISTORY_CODES.C2_REQUEST_EXPIRED]: 'Request expired',
  [HISTORY_CODES.C2_L1_TX_HANDLED]: 'L1 transaction handled',
  [HISTORY_CODES.C2_REQUEST_EXECUTED]: 'Request executed',
  [HISTORY_CODES.C2_COLLATERAL_DEPOSIT_FAILED]: 'Collateral deposit failed',
  [HISTORY_CODES.C2_COLLATERAL_WITHDRAW_FAILED]: 'Collateral withdrawal failed',
  [HISTORY_CODES.C2_COLLATERAL_DEPOSIT]: 'Collateral deposited',
  [HISTORY_CODES.C2_COLLATERAL_WITHDRAW]: 'Collateral withdrawn',
  [HISTORY_CODES.C2_COLLATERAL_LOCKED]: 'Collateral locked',
  [HISTORY_CODES.C2_COLLATERAL_UNLOCKED]: 'Collateral unlocked',
  [HISTORY_CODES.C2_REQUEST_FEE_PAID]: 'Collateral fee paid to the fee pool',
  [HISTORY_CODES.C2_FALLBACK_REFUND_CWEB]: 'Request to refund cweb created',
  [HISTORY_CODES.C2_REFUND_REQUEST_CREATED]: 'Request to refund created',
  [HISTORY_CODES.C2_REFUND_REQUEST_EXECUTED]: 'Request to refund executed',
} as const satisfies Record<HISTORY_CODES, string>;

export enum HighlightColor {
  red = 'red',
  orange = 'orange',
  yellow = 'yellow',
  lime = 'lime',
  green = 'green',
  teal = 'teal',
  cyan = 'cyan',
  indigo = 'indigo',
  violet = 'violet',
  purple = 'purple',
  fuchsia = 'fuchsia',
  pink = 'pink',
  white = 'white',
}

export const BorderHighlight: Record<
  HighlightColor,
  `border-${HighlightColor}` | `border-${HighlightColor}-${number}`
> = {
  red: 'border-red-500',
  orange: 'border-orange-500',
  yellow: 'border-yellow-500',
  lime: 'border-lime-500',
  green: 'border-green-500',
  teal: 'border-teal-500',
  cyan: 'border-cyan-500',
  indigo: 'border-indigo-500',
  violet: 'border-violet-500',
  purple: 'border-purple-500',
  fuchsia: 'border-fuchsia-500',
  pink: 'border-pink-500',
  white: 'border-white',
};

export const historyErrorCodes: ErrorHistoryCode[] = [
  HISTORY_CODES.BATCH_ERROR,
  HISTORY_CODES.ERROR,
  HISTORY_CODES.BAD_REQUEST,
  HISTORY_CODES.FORBIDDEN,
  HISTORY_CODES.NOT_FOUND,
  HISTORY_CODES.CONFLICT,
  HISTORY_CODES.CONTRACT_ERROR,
  HISTORY_CODES.NOT_IMPLEMENTED,
  HISTORY_CODES.TIMEOUT,
  HISTORY_CODES.BATCH_ERROR,
  HISTORY_CODES.C1_ORDER_NOT_CREATED,
  HISTORY_CODES.C1_ORDER_NOT_CLOSED,
  HISTORY_CODES.C1_ORDER_NOT_ACTIVE,
  HISTORY_CODES.C1_L1_TX_HANDLING_ERROR,
  HISTORY_CODES.C1_BAD_L1_TX,
  HISTORY_CODES.C2_ORDER_NOT_CREATED,
  HISTORY_CODES.C2_ORDER_NOT_CLOSED,
  HISTORY_CODES.C2_ORDER_NOT_ACTIVE,
  HISTORY_CODES.C2_REQUEST_NOT_CREATED,
  HISTORY_CODES.C2_FITTING_ORDER_NOT_FOUND,
  HISTORY_CODES.C2_BTC_NONCE_NOT_AVAILABLE,
  HISTORY_CODES.C2_L1_TX_HANDLING_ERROR,
  HISTORY_CODES.C2_BAD_L1_TX,
  HISTORY_CODES.C2_REQUEST_NOT_ACTIVE,
  HISTORY_CODES.C2_REQUEST_EXPIRED,
  HISTORY_CODES.C2_COLLATERAL_DEPOSIT_FAILED,
  HISTORY_CODES.C2_COLLATERAL_WITHDRAW_FAILED,
];

export enum HISTORY_STATUS {
  OK = 'OK',
  ERROR = 'ERROR',
}

export const linkMessages = {
  orderC1: 'C1 Order',
  orderC2: 'C2 Order',
  swap: 'SWAP',
  collateral: 'Collateral',
  batch: 'Batch',
  take: 'Take',
  l1Tx: 'L1 Tx',
  unknown: 'Unknown',
};
